import React from 'react';
import moment from 'moment';

import { BASE_ICONS } from 'src/components/svg';

import { MCButton } from '../basic';

export class MCDatePicker extends React.PureComponent {
  constructor(props) {
    super(props);
    const selected = props.selected !== 'object' ? moment(props.selected) : props.selected;
    const current =
      !!props.current && props.current !== 'object' ? moment(props.current) : props.current;
    this.state = {
      monthDate: current || selected,
      selectedDate: selected,
      year: selected.year()
    };
  }

  static getDerivedStateFromProps(props, state) {
    const selected = props.selected !== 'object' ? moment(props.selected) : props.selected;
    if (selected !== state.selectedDate) {
      return {
        selectedDate: selected
      };
    }
    return null;
  }

  nextMonth = () => {
    const { monthDate: d } = this.state;
    const monthDate = d.clone().add(1, 'months');
    this.setState({ monthDate, year: monthDate.year() });

    const { onSetMonth } = this.props;
    onSetMonth && onSetMonth(monthDate);
  };

  prevMonth = () => {
    const { monthDate: d } = this.state;
    const monthDate = d.clone().add(-1, 'months');
    this.setState({ monthDate, year: monthDate.year() });

    const { onSetMonth } = this.props;
    onSetMonth && onSetMonth(monthDate);
  };

  setYear = (i) => {
    if (i !== undefined) {
      this.setState({ year: i });
      return;
    }
    const { monthDate: d } = this.state;
    i = this.state.year;
    if (moment().year() - 100 >= i || moment().year() + 100 <= i) {
      i = d.year();
    }
    const monthDate = d.clone().year(i);
    this.setState({ monthDate, year: monthDate.year() });

    const { onSetMonth } = this.props;
    onSetMonth && onSetMonth(monthDate);
  };

  setNewSelectedDate = (date, e) => {
    if (e && this.props.onWeek) {
      e.stopPropagation();
    }
    if (e.target.className.indexOf('disabled') === -1) {
      this.setState({ selectedDate: date.clone() });
      this.props.onChange && this.props.onChange(date.clone());
    }
  };

  classNamesOfCell = (date) => {
    const { selectedDate, monthDate } = this.state;
    const { minDate, maxDate, hasPastClass = false, onClassNamesOfCell } = this.props;
    const classNames = ['mc-cell'];
    if (hasPastClass && date.format('MMDDYYYY') < moment().format('MMDDYYYY')) {
      classNames.push('mc-past');
    }
    if (date.format('MMDDYYYY') === selectedDate.format('MMDDYYYY')) {
      classNames.push('selected');
    }
    if (minDate && date.format('YYYYMMDD') < minDate.format('YYYYMMDD')) {
      classNames.push('disabled');
    }
    if (maxDate && date.format('YYYYMMDD') > maxDate.format('YYYYMMDD')) {
      classNames.push('disabled');
    }
    if (date.format('MM') !== monthDate.format('MM')) {
      classNames.push('inactive');
    }
    onClassNamesOfCell && onClassNamesOfCell(date, classNames);
    return classNames;
  };

  get dates() {
    const { monthDate } = this.state;
    const { onWeek } = this.props;
    let startDay = monthDate.clone().startOf('month').startOf('isoWeek');
    const endDay = monthDate.clone().endOf('month').endOf('isoWeek');
    const dates = [],
      weeks = [];
    let count = 0,
      selectedWeek = 0;
    while (startDay.isSameOrBefore(endDay)) {
      let date = startDay.clone();
      let numWeek = Math.floor(count / 7);
      if (!dates[numWeek]) {
        dates[numWeek] = [];
        weeks[numWeek] = startDay.valueOf();
      }

      dates[numWeek].push(
        <button
          key={date.format('DDMMYYYY')}
          type={'button'}
          onClick={(e) => this.setNewSelectedDate(date, e)}
          className={this.classNamesOfCell(date).join(' ')}
        >
          {date.format('DD')}
        </button>
      );
      if (this.classNamesOfCell(date).indexOf('selected') > -1) selectedWeek = numWeek.toString();

      startDay = startDay.add(1, 'days');
      count++;
    }

    return Object.keys(dates).map((week) => (
      <div
        key={'week-' + week}
        className={
          'mc-row ' +
          (selectedWeek.toString() === week ? 'selected' : '') +
          (onWeek ? ' hover' : '')
        }
        onClick={() => {
          if (onWeek) onWeek(weeks[week]);
        }}
      >
        {dates[week]}
      </div>
    ));
  }

  render() {
    const { monthDate, selectedDate } = this.state;
    let {
      className = '',
      isSmall = true,
      isMedium = false,
      isSMedium = false,
      expandRightChild = '',
      style,
      monthStyle
    } = this.props;
    if (isMedium) {
      isSmall = false;
      className += ' mc-medium';
    }
    if (isSMedium) {
      isSmall = false;
      className += ' mc-s-medium';
    }
    if (isSmall) {
      className += ' mc-small';
    }

    return (
      <div className={`mc-datepicker ${className ?? ''}`} style={style}>
        <div className={'mc-datepicker-month'} style={monthStyle}>
          <MCButton
            light
            primary
            medium={!isSmall}
            small={isSmall}
            width={isSMedium ? 50 : null}
            padding={isSMedium ? 8 : null}
            radius
            iconname={BASE_ICONS.LEFT}
            onClick={this.prevMonth}
          />
          <div className={'mc-month-title'}>
            {monthDate.format('MMMM, ')}
            <input
              className='mc-input-year'
              type={'number'}
              onBlur={() => this.setYear()}
              onChange={(e) => this.setYear(e.target.value)}
              value={this.state.year}
            />
          </div>
          <MCButton
            light
            primary
            medium={!isSmall}
            small={isSmall}
            width={isSMedium ? 50 : null}
            padding={isSMedium ? 8 : null}
            radius
            iconname={BASE_ICONS.RIGHT}
            onClick={this.nextMonth}
          />
          {expandRightChild}
        </div>
        <div
          className={`mc-datepicker-calendar ${
            monthDate.format('MMYYYY') === selectedDate.format('MMYYYY') ? 'is-month-selected' : ''
          }`}
        >
          <div className={'mc-row-header'}>
            {['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'].map(
              (v) => (
                <div key={v}>
                  {isSmall ? v.slice(0, 2) : isMedium || isSMedium ? v.slice(0, 1) : v}
                </div>
              )
            )}
          </div>
          {this.dates}
        </div>
      </div>
    );
  }
}
